
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  EventEmitter,
  Output,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AppointmentService, ClientService, TimeconversionService, ToastMessageService } from '@fitness-force/api';
import { AppErrors, ErrorMsgComponent } from '@fitness-force/errors';
import {
  Appointment,
  AppointmentBookingResponse,
  AppointmentById,
  AppointmentType,
  CancelAppointmentRequest,
  Membership,
  RepeatRuleResponse,
  RescheduleAppointmentRequest,
  RescheduleRecurringAppointmentRequest,
  Room,
  SubstituteCoachRequest,
  UpdateAppointmentMembership,
  UpdateAppointmentRequest,
  UpdateMembership,
} from '@fitness-force/models';

import { Store } from '@ngrx/store';
import { APPOINTMENT_TYPE_STATE, STAFF_STATE } from 'apps/ff-frontend/src/app/state/app.state';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';

import { PopoverModule } from 'primeng/popover';
import { StyleClassModule } from 'primeng/styleclass';

import { BehaviorSubject, debounceTime, Observable, Subject } from 'rxjs';
import { TranslateModule, TranslateService, } from '@ngx-translate/core';
import { AppointmentStatus, ClassAppointmentBehaviour, Ienum, StaffStatus } from '@fitness-force/enum';
import { rrulestr } from 'rrule';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TooltipModule } from 'primeng/tooltip';
import { DuplicateAppointmentComponent } from '../duplicate-appointment/duplicate-appointment.component';
import { DrawerModule } from 'primeng/drawer';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { DateTimeFormatPipe } from '@fitness-force/pipes/datetime-format';
import { ShortNamePipe } from '@fitness-force/pipes/short-name'
import { ErrorsComponent,} from '@fitness-force/common/errors'
import { RruleComponent } from '../../../rrule/rrule.component';
import { SelectRoomComponent } from '../../../select-room/select-room.component';
import { AssignedToComponent} from '@fitness-force/common/assigned-to'
import { MessageModule } from 'primeng/message';
import { CheckRecurringAvailability, StaffAvailableResponse } from 'libs/staff-availability-lib/src/lib/models/staff-availability';
import { StaffAvailabilityService } from 'libs/staff-availability-lib/src/lib/services/staff-availability.service';
import { SkeletonModule } from 'primeng/skeleton';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { StaffAppointmentTypeLinkService } from 'libs/staff-availability-lib/src/lib/services/staff-appointment-type-link.service';
import { StaffAppointmentTytpeLink, StaffAppointmentTytpeLinkResponse } from 'libs/staff-availability-lib/src/lib/models/StaffAppointmentTytpeLink';
import { CommonModule, DatePipe } from '@angular/common';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'view-appointment',
  templateUrl: './view-appointment.component.html',
  styleUrls: ['./view-appointment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [],
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    InputTextModule,
    ButtonModule,
    SelectModule,
    DividerModule,
    AvatarModule,
    StyleClassModule,
    FormsModule,
    ReactiveFormsModule,
    RruleComponent,
    AssignedToComponent,
    ErrorsComponent,
    ErrorMsgComponent,
    PopoverModule,
    DateTimeFormatPipe,
    DatePickerModule,
    RadioButtonModule,
    TooltipModule,
    DuplicateAppointmentComponent,
    DrawerModule,
    ToggleSwitchModule,
    ShortNamePipe,
    SelectRoomComponent,
    MessageModule,
    SkeletonModule,
    ConfirmPopupModule,
    TranslateModule,
    MessageModule
],
})
export class ViewAppointmentComponent implements OnInit {
  @Input('visible') viewAppointmentSidebar: boolean = false;
  @Input('tenantId') tenantId: number = 0;
  @Input('eventData') eventData: any;
  @Input('appointmentData') appointmentData!: Appointment;
  @Output('CloseViewAppointment') hideViewAppointment: EventEmitter<boolean> = new EventEmitter();
  @Output('emitUpdatedData') emitUpdatedData: EventEmitter<any> = new EventEmitter();
  @Output('reloadData') reloadData: EventEmitter<any> = new EventEmitter();

  @ViewChild('virtualUrl') virtualUrl: ElementRef | undefined;

  showApptSubType = new BehaviorSubject(false);
  getAccessedStaffList$: Observable<any> | any;
  appointmentTypeList$ = new BehaviorSubject<any[]>([]);
  appointmentSubTypeList$ = new BehaviorSubject<any[]>([]);
  roomList$ = new BehaviorSubject<any[]>([]);
  appointment!: AppointmentById;

  appointmentAttended: Observable<boolean> | any = false;
  appointmentNoShow: Observable<boolean> | any = false;

  selectedApptSubType: Observable<any> | any;
  selectedApptType: Observable<any> | any;
  selectedTrainerId = new BehaviorSubject(0);
  selectedRoomId = new BehaviorSubject(0);
  selectedBehaviourType: any;
  selectedRoom: { name: string } | any;
  selectedTrainer: | { name: string; availability: string; ff_picture: string } | undefined;

  appointmentViewForm: UntypedFormGroup = new UntypedFormGroup({});
  duplicateAppointmentForm: UntypedFormGroup = new UntypedFormGroup({});
  deleteAppointmentForm: UntypedFormGroup = new UntypedFormGroup({});
  updateEventForm: UntypedFormGroup = new UntypedFormGroup({});

  startDateTime: any;
  isVirtal: boolean = false;
  commnetsEdit: boolean = false;

  private url = new Subject<string>();
  private comments = new Subject<string>();
  duplicateAppointment: boolean = false;
  types = ClassAppointmentBehaviour;

  behaviours(): Array<string> {
    var keys = Object.keys(this.types);
    return keys.slice(keys.length / 2);
  }

  showRRule: boolean = false;
  RRuleObject = <RepeatRuleResponse>{};
  minimumDate = new Date();
  errorDataModal = [] as any;
  errorMessages = [] as any;
  showErrorPopup$ = new BehaviorSubject(false);
  cancelAppointment: boolean = false;

  showRecurringEventUpdatePopup: boolean = false;
  updateOnlyThisEvent: boolean = true;

  updateEvent: string = '';
  currentRequestPayload: any;

  rescheduleDate: any;
  rescheduleTime: any;

  isApptAttendedOrCancelled: boolean = false;
  error = new BehaviorSubject(null as (AppErrors | null));
  filterStaffIds = new BehaviorSubject<number[]>([0]);
  appointmentCreateResponse: AppointmentBookingResponse;

  clientMemberships: Membership[];
  selectedMembership: Membership | null;

  dateSelectionOption: any;
  timeSelectionOption: any;

  showMedicalAlert: boolean = false;
  clientMedicalDetails: any;

  Actions: any[];
  selectedAction: { key: string, name: string, icon: string; } | undefined;
  isStaffAvailable:boolean=true;
  staffAppointmentAvailability: any = new Map();
  btnLoading:boolean=false;
  checkAvailability:boolean=true;

  staffAppointmentTypeLinks = [] as StaffAppointmentTytpeLink[];
  allStaffs:[]= [];

  showCompSessionPopup:boolean=false;
  complimentoryForm: UntypedFormGroup = new UntypedFormGroup({});
  isComplimentoryLoading:boolean=false;

  constructor(
    private store: Store,
    private translate: TranslateService,
    private fb: UntypedFormBuilder,
    private toastMessageService: ToastMessageService,
    private appointmentService: AppointmentService,
    private timeConversionService: TimeconversionService,
    public datePipe: DatePipe,
    private clientService: ClientService,
    private staffAvailabilityService: StaffAvailabilityService,
    private confirmationService: ConfirmationService,
    public cd: ChangeDetectorRef,
    private staffAppointmentTypeLinkService: StaffAppointmentTypeLinkService,
  ) {
    this.dateSelectionOption = {
     
    };

    this.Actions = [
      { key: "DUPLICATE", name: 'Make a duplicate appointment', icon: 'fa fa-copy font-light', show: true },
      { key: "CANCEL_APPT", name: 'Cancel this appointment', icon: 'fa fa-minus-circle', show: true },
      // { key:"DELETE", name: 'Delete this appointment', icon: 'fa fa-times text-xl-circle', show:true },
      { key: "CONVERT_PHYSICAL", name: 'Convert this appointment to physical', icon: 'fa fa-building', show: true },
      { key: "CONVERT_VIRTUAL", name: 'Convert this appointment to Virtual', icon: 'fa fa-video', show: true },
      { key: "CONVERT_COMPLIMENTORY", name: 'Mark this appointment as Complimentory', icon: 'fa fa-calendar-times', show: true }
    ];

  }

  ngOnInit(): void {
    this.componentInit();
  }

  componentInit() {
    this.startDateTime = this.appointmentData.start_datetime;
    this.selectedTrainerId.next(this.appointmentData.coach_id);
    this.selectedRoomId.next(this.appointmentData.room_id);
    this.isApptAttendedOrCancelled = this.appointmentData!.status == AppointmentStatus.Attended.toString() ||
      this.appointmentData!.status.toLowerCase() == AppointmentStatus[AppointmentStatus.Attended] ||
      this.appointmentData!.status == AppointmentStatus.Cancelled.toString() ||
      this.appointmentData!.status.toLowerCase() == AppointmentStatus[AppointmentStatus.Cancelled] ? true : false;

    this.appointmentViewForm = this.fb.group({
      selectedTrainer: ['', [Validators.required]],
      startDate: [this.startDateTime, [Validators.required]],
      selectedRoom: ['', [Validators.required]],
      comments: ['', [Validators.required]],
      virtualUrl: [this.appointmentData?.virtual_url, [Validators.required]],
      rRule: [''],
      selectedMembership: [this.selectedMembership],
      //accepts_trial:[this.appointmentData?.accepts_trial],
      selectedAction: []
    });

    this.complimentoryForm = this.fb.group({
      comments: ['', [Validators.required]],
    });

    this.SetFormData();
    this.GetAppointment();
    this.GetAppointmentTypes();
    this.GetStaffs();
  }

  ngAfterViewInit() {
    this.deleteAppointmentForm = this.fb.group({
      cancellation_reason: ['', [Validators.required]],
    });

    this.updateEventForm = this.fb.group({
      updateEvent: ['ThisEvent', [Validators.required]],
    });

    this.url.pipe(debounceTime(2000)).subscribe(() => {
      this.UpdateVirtualUrl();
    });

    this.comments.pipe(debounceTime(2000)).subscribe(() => {
      let updateAppointmentRequest: UpdateAppointmentRequest = {} as UpdateAppointmentRequest;
      updateAppointmentRequest.room_id = this.GetSelectedRoom.id;
      updateAppointmentRequest.comments = this.Getcomments;
      updateAppointmentRequest.is_virtual = this.isVirtal;
      updateAppointmentRequest.virtual_url = this.GetVirtualUrl;
      //updateAppointmentRequest.accepts_trial = this.GetAcceptsTrial;
      this.updateEvent = 'CommentsEdit';
      this.currentRequestPayload = updateAppointmentRequest;
      if (this.appointment!.is_recurring)
        this.showRecurringEventUpdatePopup = true;
      else this.UpdateAppopintment(updateAppointmentRequest);
    });

  }

  public onKeyUpDelay(value: string): void {
    this.url.next(value);
  }

  public onCommentsKeyUpDelay(value: string): void {
    this.comments.next(value);
  }

  SetFormData() {
    if (this.appointmentData.recurring_rule) {
      this.RRuleObject.RRule = this.appointmentData.recurring_rule;
      this.RRuleObject.RRuleText = rrulestr(this.appointmentData.recurring_rule).toText();
    }
    this.isVirtal = this.appointmentData?.is_virtual;
    if (this.appointmentData?.status == AppointmentStatus.Attended.toString() || this.appointmentData?.status == AppointmentStatus[AppointmentStatus.Attended])
      this.appointmentAttended = true;
    if (this.appointmentData?.status == AppointmentStatus.NoShow.toString() || this.appointmentData?.status == AppointmentStatus[AppointmentStatus.NoShow])
      this.appointmentNoShow = true;

    this.checkAppointmentcancelledOrAttended();
  }

  GetAppointment() {
    this.appointmentService.GetAppointment(this.tenantId, this.appointmentData!.id).subscribe({
      next: (response: AppointmentById) => {
        this.appointment = response;
        if (this.appointment.client_booked_details) {
          this.clientMemberships = this.appointment.client_booked_details.memberships;
          if (this.clientMemberships != null)
            this.selectedMembership = this.appointment.client_booked_details.memberships.find(m => m.is_selected == true)!;
          else this.selectedMembership = null;
          this.appointmentViewForm.controls.selectedMembership.setValue(this.selectedMembership);
        }
        this.CommnetFormControl.setValue(this.appointment.comments);
        this.CommnetFormControl.updateValueAndValidity();
      },
      error: (error) => { },
    });
  }

  GetAppointmentTypes() {
    this.store.select(APPOINTMENT_TYPE_STATE).subscribe((responseData: AppointmentType[]) => {
      this.appointmentTypeList$.next(responseData);
      this.selectedApptType = this.appointmentTypeList$.value.find(
        (type: { id: number }) => type.id == this.appointmentData.type_id
      );
      this.GetStaffAppointmentLink( this.selectedApptType.id);
    });
  }

  GetStaffs() {
    this.store.select(STAFF_STATE).subscribe((data: any) => {
      if (data && data.staffList && data.staffList.length > 0) {
        let validStaff: number[] = [];
        this.allStaffs = data.staffList;
        let staffs = data.staffList;
        if(this.staffAppointmentTypeLinks.length > 0)
        {
          staffs = this.allStaffs.filter((staff:any) => this.staffAppointmentTypeLinks.find( link => staff.id == link.staff_id));
        }
        this.getAccessedStaffList$ = staffs.filter((staff: any) => {
          let oStaffStatus = this.OStaffStatus.find((o: any) => (o.value == staff.status || o.key == staff.status));
          if (oStaffStatus!.value == StaffStatus.Active || oStaffStatus!.key == StaffStatus.Active) {
            if (staff.role.toLowerCase() == 'admin' || (staff.role.toLowerCase() == 'staff')) {
              validStaff.push(staff.id);
              return staff;
            }
          }
        });
        this.filterStaffIds.next(validStaff);
      }
    });
  }

  GetStaffAppointmentLink(appointmentTypeId: number) {
    this.staffAppointmentTypeLinkService.GetStaffAppointmentLinkByCategoryId(this.tenantId,appointmentTypeId)
      .subscribe((response: StaffAppointmentTytpeLinkResponse) => {
        this.staffAppointmentTypeLinks = response.items ? response.items : [];
        if (this.staffAppointmentTypeLinks.length > 0) {
          let validStaff: number[] = [];
          let staffs = this.allStaffs.filter((staff:any) => this.staffAppointmentTypeLinks.find( link => staff.id == link.staff_id));
          this.getAccessedStaffList$ = staffs.filter((staff: any) => {
            let oStaffStatus = this.OStaffStatus.find(
              (o: any) => o.value == staff.status || o.key == staff.status
            );
            if (oStaffStatus!.value == StaffStatus.Active || (oStaffStatus!.key == StaffStatus.Active)) {
              if (staff.role.toLowerCase() == 'admin' || (staff.role.toLowerCase() == 'staff')) {
                validStaff.push(staff.id);
                return staff;
              }
            }
          });
          this.filterStaffIds.next(validStaff);
          this.cd.detectChanges();
        }
      });
  }

  CloseViewAppointmentSidebar() {
    this.viewAppointmentSidebar = false;
    this.duplicateAppointment = false;
    this.hideViewAppointment.emit(this.viewAppointmentSidebar);
  }

  checkAppointmentcancelledOrAttended() {
    if (this.isApptAttendedOrCancelled) {
      Object.keys(this.appointmentViewForm.controls).forEach((field) => {
        const control = this.appointmentViewForm.get(field);
        if (field != 'selectedAction')
          control?.disable({ onlySelf: true });
      });
    }
    if (this.isApptAttendedOrCancelled)
      this.Actions.forEach(o => {
        if (o.key.toLowerCase() == 'cancel_appt' || o.key.toLowerCase() == 'convert_physical' || o.key.toLowerCase() == 'convert_virtual')
          o.show = false;
      });
    else if (this.isVirtal)
      this.Actions.forEach(o => { if (o.key.toLowerCase() == 'convert_virtual') o.show = false; });
    else
      this.Actions.forEach(o => { if (o.key.toLowerCase() == 'convert_physical') o.show = false; });

    if(this.appointmentData.status == AppointmentStatus.Attended || this.appointmentData.status.toString() == AppointmentStatus[AppointmentStatus.Attended] || this.appointmentData.status == AppointmentStatus.NoShow || this.appointmentData.status.toString() == AppointmentStatus[AppointmentStatus.NoShow])
      this.Actions.forEach(o => { if (o.key.toLowerCase() == 'convert_complimentory') o.show = true; });
    else
      this.Actions.forEach(o => { if (o.key.toLowerCase() == 'convert_complimentory') o.show = false; });
  }

  async getSelectedStaff(trainer: any) {
  
    this.onTrainerChange(trainer);
  }

  getSelectedRoomEvent(room: Room) {
    this.UpdateRoom();
  }

  UpdateVirtualUrl() {
    let updateAppointmentRequest: UpdateAppointmentRequest = {} as UpdateAppointmentRequest;
    updateAppointmentRequest.room_id = 0;
    updateAppointmentRequest.comments = this.Getcomments;
    updateAppointmentRequest.is_virtual = true;
    updateAppointmentRequest.virtual_url = this.GetVirtualUrl;
    this.updateEvent = 'VirtualURLChange';
    this.currentRequestPayload = updateAppointmentRequest;
    if (this.appointment!.is_recurring)
      this.showRecurringEventUpdatePopup = true;
    else this.UpdateAppopintment(updateAppointmentRequest);
  }

  UpdateRoom() {
    let updateAppointmentRequest: UpdateAppointmentRequest = {} as UpdateAppointmentRequest;
    updateAppointmentRequest.room_id = this.SelectedRoomFormControl.value.id;
    updateAppointmentRequest.comments = this.Getcomments;
    updateAppointmentRequest.is_virtual = false;
    updateAppointmentRequest.virtual_url = this.VirtualUrlFormControl.value;
    //updateAppointmentRequest.accepts_trial = this.GetAcceptsTrial;
    this.updateEvent = 'RoomChange';
    this.currentRequestPayload = updateAppointmentRequest;
    if (this.appointment!.is_recurring)
      this.showRecurringEventUpdatePopup = true;
    else this.UpdateAppopintment(updateAppointmentRequest);
  }



  async onTrainerChange(trainer: any) {
    let substituteCoach: SubstituteCoachRequest = {} as SubstituteCoachRequest;
    substituteCoach.coach_id = trainer.id;
    this.updateEvent = 'TrainerChange';
    this.currentRequestPayload = substituteCoach;
    if (this.appointment!.is_recurring) {
      this.showRecurringEventUpdatePopup = true;
    } else {
      this.checkStaffAvailability();
      await this.timeout(1000);

      await this.SubstituteCoach(substituteCoach);
    }
  }

  onAcceptTrialChange(event: any) {
    let updateAppointmentRequest: UpdateAppointmentRequest = {} as UpdateAppointmentRequest;
    updateAppointmentRequest.room_id = this.GetSelectedRoom.id;
    updateAppointmentRequest.comments = this.Getcomments;
    updateAppointmentRequest.is_virtual = this.isVirtal;
    updateAppointmentRequest.virtual_url = this.GetVirtualUrl;
    //updateAppointmentRequest.accepts_trial = this.GetAcceptsTrial;
    this.updateEvent = 'AcceptsTrialChange';
    this.currentRequestPayload = updateAppointmentRequest;
    if (this.appointment!.is_recurring)
      this.showRecurringEventUpdatePopup = true;
    else this.UpdateAppopintment(updateAppointmentRequest);
  }

  async OnScheduleDateSelect(event: any) {
    console.log(this.StartDateFormControl.value);
    let changedDate = this.StartDateFormControl.value;
    if(changedDate != this.appointmentData.start_datetime)
    {
      if (this.appointment!.is_recurring) {
        if(changedDate > this.appointmentData.end_datetime)
          this.checkAvailability=true;
        else
          this.checkAvailability=false;
        this.rescheduleDate = this.timeConversionService.ConvertLocalDateTimeToUTC(changedDate);
        this.rescheduleTime = this.timeConversionService.GetUTCTimeFromDate(changedDate);
        this.updateEvent = 'OnScheduleDateSelect';
        this.showRecurringEventUpdatePopup = true;
      } else {
        this.rescheduleDate = this.timeConversionService.ConvertLocalDateTimeToUTC(changedDate);
        this.checkStaffAvailability();
        await this.timeout(500);
        this.RescheduleAppointment(this.rescheduleDate);
      }
    }
  }

  async OnRRuleChange() {
    if (this.StartDateFormControl.value) {
      this.checkStaffAvailability();
      await this.timeout(1000);
      this.rescheduleDate = this.timeConversionService.ConvertLocalDateTimeToUTC(this.StartDateFormControl.value);
      this.rescheduleTime = this.timeConversionService.GetUTCTimeFromDate(this.StartDateFormControl.value);
      this.RescheduleRecurringAppointments(this.rescheduleDate, this.rescheduleTime);
    }
  }

  MarkClientAsAttended(appointmentAttended: boolean) {
    if (!appointmentAttended) {
      this.appointmentService.MarkClientCheckIn(this.tenantId, this.appointmentData!.id)
        .subscribe({
          next: (data: any) => {
            this.appointmentAttended = true;
            this.isApptAttendedOrCancelled = true;
            this.appointment.status = AppointmentStatus.Attended;
            this.appointmentData.status = AppointmentStatus.Attended;
            this.emitUpdatedData.emit({
              appointment: this.appointmentData,
              event: this.eventData
            });
            this.checkAppointmentcancelledOrAttended();
            this.translate.get('SCHEDULE.MSG.MARK_CHECKEDIN_MSG')
              .subscribe((translation) => {
                this.toastMessageService.showSuccess(translation);
              });
          },
          error: (error: AppErrors) => {
            this.handleToastError(error);
          },
        });
    }
  }

  MarkClientAsNoShow(appointmentNoShow: boolean) {
    if (!appointmentNoShow) {
      this.appointmentService
        .MarkClientNoShow(this.tenantId, this.appointmentData!.id)
        .subscribe({
          next: (data: any) => {
            this.appointmentNoShow = true;
            this.appointment.status = AppointmentStatus.NoShow;
            this.appointmentData.status = AppointmentStatus.NoShow;
            this.emitUpdatedData.emit({
              appointment: this.appointmentData,
              event: this.eventData
            });
            this.translate.get('SCHEDULE.MSG.MARK_NOSHOW_MSG')
              .subscribe((translation) => {
                this.toastMessageService.showSuccess(translation);
              });
          },
          error: (error: AppErrors) => {
            this.handleToastError(error);
          },
        });
    }
  }

  CancelAppointment(form: any) {
    let cancelRequest: CancelAppointmentRequest = {} as CancelAppointmentRequest;
    cancelRequest.cancellation_reason = form.value.cancellation_reason;
    this.appointmentService.CancelAppointment(this.tenantId, this.appointmentData!.id, cancelRequest)
      .subscribe({
        next: async (data: any) => {
          this.translate.get('SCHEDULE.MSG.CANCEL_APPT')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          this.reloadData.emit(true);
          await this.timeout(1000);
          this.CloseViewAppointmentSidebar();
        },
        error: (error: AppErrors) => {
          this.handleToastError(error);
        },
      });
  }

  async SubstituteCoach(substituteCoach: SubstituteCoachRequest) {
    this.appointmentService.SubstituteCoach(this.tenantId, this.appointmentData!.id, substituteCoach)
      .subscribe({
        next: async (data: any) => {
          this.translate.get('SCHEDULE.MSG.COACH_CHANGE')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          this.appointmentData.coach_id = substituteCoach.coach_id;
          if (this.eventData) this.eventData!.resource = substituteCoach.coach_id;
          this.selectedTrainerId.next(this.appointmentData!.coach_id);
          this.emitUpdatedData.emit({
            appointment: this.appointmentData,
            event: this.eventData
          });
        },
        error: (error: AppErrors) => {
          this.handleToastError(error);
          this.selectedTrainerId.next(this.appointmentData!.coach_id);
        },
      });
  }

  async SubstituteCoachInRecurring(substituteCoach: SubstituteCoachRequest) {
    this.appointmentService.SubstituteCoachInRecurring(
      this.tenantId,
      this.appointmentData!.recurring_template_id,
      substituteCoach
    )
      .subscribe({
        next: async (data: any) => {
          this.translate.get('SCHEDULE.MSG.COACH_CHANGE')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          this.appointmentData.coach_id = substituteCoach.coach_id;
          if (this.eventData) this.eventData!.resource = substituteCoach.coach_id;
          this.selectedTrainerId.next(this.appointmentData!.coach_id);
          this.reloadData.emit(true);
        },
        error: (error: AppErrors) => {
          this.handleToastError(error);
          this.selectedTrainerId.next(this.appointmentData!.coach_id);
        },
      });
  }

  async UpdateAppopintment(updateAppointmentRequest: UpdateAppointmentRequest) {
    this.appointmentService.UpdateAppointment(this.tenantId, this.appointmentData!.id, updateAppointmentRequest)
      .subscribe({
        next: async (data: any) => {
          this.translate.get('SCHEDULE.MSG.APPT_UPDATE')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          this.appointmentData.room_id = updateAppointmentRequest.room_id;
          this.selectedRoomId.next(updateAppointmentRequest.room_id);
          this.appointment.comments = updateAppointmentRequest.comments;
          this.appointmentData.is_virtual = updateAppointmentRequest.is_virtual;
          this.appointmentData.virtual_url = updateAppointmentRequest.virtual_url;
          //this.appointment.accepts_trial = updateAppointmentRequest.accepts_trial;
          this.emitUpdatedData.emit({
            appointment: this.appointmentData,
            event: this.eventData
          });
        },
        error: (error: AppErrors) => {
          this.handleToastError(error);
          this.selectedRoomId.next(this.appointment.room_id);
          this.CommnetFormControl.setValue(this.appointment!.comments);
          this.VirtualUrlFormControl.setValue(this.appointment!.virtual_url);
          //this.AcceptsTrialFormControl.setValue(this.appointment!.accepts_trial);
        },
      });
  }

  async UpdateRecurringAppopintment(updateAppointmentRequest: UpdateAppointmentRequest) {
    this.appointmentService.UpdateRecurringAppointment(this.tenantId, this.appointmentData!.recurring_template_id, updateAppointmentRequest)
      .subscribe({
        next: async (data: any) => {
          this.translate.get('SCHEDULE.MSG.RECC_APPT_UPDATE')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          this.appointmentData.room_id = updateAppointmentRequest.room_id;
          this.appointment.comments = updateAppointmentRequest.comments;
          this.appointmentData.is_virtual = updateAppointmentRequest.is_virtual;
          this.appointmentData.virtual_url = updateAppointmentRequest.virtual_url;
          //this.appointmentData.accepts_trial = updateAppointmentRequest.accepts_trial;
          this.reloadData.emit(true);
        },

        error: async (error: AppErrors) => {
          this.handleToastError(error);
          this.selectedRoomId.next(this.appointment!.room_id);
          this.CommnetFormControl.setValue(this.appointment!.comments);
        },
      });
  }

  RescheduleAppointment(eventDateTime: string) {
    let rescheduleAppointmentRequest: RescheduleAppointmentRequest = {} as RescheduleAppointmentRequest;
    rescheduleAppointmentRequest.start_datetime = eventDateTime;
    this.appointmentService.RescheduleAppointment(this.tenantId, this.appointmentData!.id, rescheduleAppointmentRequest).subscribe({
      next: async (data: any) => {
        this.translate.get('SCHEDULE.MSG.APPT_RESCHEDULE_CHANGE')
          .subscribe((translation) => {
            this.toastMessageService.showSuccess(translation);
          });
        this.appointmentData!.start_datetime = this.StartDateFormControl.value;
        this.appointmentData!.end_datetime = this.getEndDate();
        if (this.eventData) {
          this.eventData!.start = this.appointmentData!.start_datetime;
          this.eventData!.end = this.appointmentData!.end_datetime;
        }
        this.emitUpdatedData.emit({ appointment: this.appointmentData, event: this.eventData });
      },
      error: (error: AppErrors) => {
        this.handleToastError(error);
        this.StartDateFormControl.setValue(this.appointmentData!.start_datetime, { onlySelf: true });
      },
    });
  }

  RescheduleRecurringAppointments(startDate: string, startTime: string) {
    let rescheduleRecurringApptRequest: RescheduleRecurringAppointmentRequest = {} as RescheduleRecurringAppointmentRequest;
    rescheduleRecurringApptRequest.recurring_rule = this.RRuleObject.RRule;
    rescheduleRecurringApptRequest.recurring_start_date = startDate;
    rescheduleRecurringApptRequest.start_time = startTime;
    this.appointmentService.RescheduleRecurringAppointment(
      this.tenantId,
      this.appointment!.recurring_template_id,
      rescheduleRecurringApptRequest
    ).subscribe({
      next: async (data: any) => {
        this.translate.get('SCHEDULE.MSG.RECC_APPT_RESCHEDULE_CHANGE')
          .subscribe((translation) => {
            this.toastMessageService.showSuccess(translation);
          });
        this.appointmentData!.start_datetime = this.StartDateFormControl.value;;
        if (this.eventData) this.eventData!.start = this.appointmentData!.start_datetime;
        this.reloadData.emit(true);
      },
      error: (error: AppErrors) => {
        if (error.originalError.error.length > 0) {
          error.originalError.error.forEach((e: any) => {
            this.toastMessageService.showErrorMessage(e.errorMessage);
          });
        } else {
          this.toastMessageService.showErrorMessage(error.originalError.error.errorMessage);
        }
        this.StartDateFormControl.setValue(this.appointmentData!.start_datetime, { onlySelf: true });
      },
    });
  }

  ChangeMembership(event: any) {
    let updateRequest: UpdateAppointmentMembership = {} as UpdateAppointmentMembership;
    let updateClientMembership: UpdateMembership = {} as UpdateMembership;
    updateClientMembership.client_id = this.appointment!.client_id;
    updateClientMembership.subscription_id = event.value.subscription_id;
    updateClientMembership.membership_id = event.value.id;
    updateRequest.clients_with_membership = updateClientMembership;
    this.appointmentService.UpdateClientmembership(this.tenantId, this.appointmentData.id, updateRequest)
      .subscribe({
        next: (data: AppointmentBookingResponse) => {
          this.appointmentCreateResponse = data;
          if (data.client_booked_details && data.client_booked_details[0].memberships) {
            this.clientMemberships = data.client_booked_details[0].memberships;
            this.selectedMembership = data.client_booked_details[0].memberships.find(m => m.is_selected == true)!;
          }
          this.translate
            .get('SCHEDULE.MSG.UPDATE_MEMBERSHIP_MSG')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
        },
        error: (error: AppErrors) => {
          this.appointmentViewForm.controls.selectedMembership.setValue(this.selectedMembership);
          this.handleToastError(error);
        },
      });
  }

  async UpdateEvent(event: boolean, clickEvent: any = null) {
    switch (this.updateEvent) {
      case 'TrainerChange':
        {
          if (event && clickEvent != null) {
            this.checkStaffAvailability(clickEvent);
          }
          else if(event && clickEvent == null){
            if (this.SelectedUpdateEventFormControlValue.toLowerCase() == 'thisevent')
               this.SubstituteCoach(this.currentRequestPayload);
            else this.SubstituteCoachInRecurring(this.currentRequestPayload);

            this.showRecurringEventUpdatePopup = false;
            this.isStaffAvailable=true;
          }
          else {
            this.selectedTrainerId.next(this.appointmentData!.coach_id);
            this.showRecurringEventUpdatePopup = false;
          }
        }
        break;
      case 'RoomChange':
        {
          if (event) {
            if (this.SelectedUpdateEventFormControlValue.toLowerCase() == 'thisevent')
              this.UpdateAppopintment(this.currentRequestPayload);
            else this.UpdateRecurringAppopintment(this.currentRequestPayload);
          }
          else {
            this.selectedRoomId.next(this.appointment!.room_id);
          }
          this.showRecurringEventUpdatePopup = false;
        }
        break;
      case 'CommentsEdit':
        {
          if (event) {
            if (this.SelectedUpdateEventFormControlValue.toLowerCase() == 'thisevent')
              this.UpdateAppopintment(this.currentRequestPayload);
            else this.UpdateRecurringAppopintment(this.currentRequestPayload);
          }
          else {
            this.CommnetFormControl.setValue(this.appointment!.comments);
          }
          this.showRecurringEventUpdatePopup = false;
        }
        break;
      case 'VirtualURLChange':
        {
          if (event) {
            if (this.SelectedUpdateEventFormControlValue.toLowerCase() == 'thisevent')
              this.UpdateAppopintment(this.currentRequestPayload);
            else this.UpdateRecurringAppopintment(this.currentRequestPayload);
          }
          else {
            this.VirtualUrlFormControl.setValue(this.appointment!.virtual_url);
          }
          this.showRecurringEventUpdatePopup = false;
        }
        break;
      case 'OnScheduleTimeChange':
      case 'OnScheduleDateSelect':
        {
          if (event && clickEvent != null) {
            this.checkStaffAvailability(clickEvent);
          }
          else if(event && (clickEvent == null || this.checkAvailability == false)){
            if (this.SelectedUpdateEventFormControlValue.toLowerCase() == 'thisevent')
             this.RescheduleAppointment(this.rescheduleDate);
           else
             this.RescheduleRecurringAppointments(this.rescheduleDate, this.rescheduleTime);

             this.showRecurringEventUpdatePopup = false;
             this.isStaffAvailable=true;
          }
          else {
            this.StartDateFormControl.setValue(this.appointmentData!.start_datetime, { onlySelf: true });
            this.showRecurringEventUpdatePopup = false;
          }
        }
        break;
      case 'AcceptsTrialChange':
        {
          if (this.SelectedUpdateEventFormControlValue.toLowerCase() == 'thisevent')
            this.UpdateAppopintment(this.currentRequestPayload);
          else this.UpdateRecurringAppopintment(this.currentRequestPayload);

          this.showRecurringEventUpdatePopup = false;
        }
        break;
    }
    this.cd.detectChanges();
  }

    confirm(event: Event) {
        let translation: any;
        this.translate.get(['STAFF_SCHEDULE.MSG.WANT_CHANGES_PROCEES','common.BUTTONS.BUTTON-TEXT-YES','common.BUTTONS.BUTTON-TEXT-NO'])
          .subscribe((translations) => {
            translation = translations;
          });
        this.confirmationService.confirm({
            target: event.target as EventTarget,
            key:'bookconfirm',
            message: translation['STAFF_SCHEDULE.MSG.WANT_CHANGES_PROCEES'],
            icon: 'fa fa-exclamation-triangle',
            acceptLabel: translation['common.BUTTONS.BUTTON-TEXT-YES'],
            rejectLabel: translation['common.BUTTONS.BUTTON-TEXT-NO'],
            accept: () => {
              this.UpdateEvent(true);
            },
            reject: () => {
              this.showRecurringEventUpdatePopup = false;
              this.isStaffAvailable=false;
            }
        });
  }

  FetchRRuleData(e: any): void {
    this.RRuleObject.RRule = e.RRule;
    this.RRuleObject.RRuleText = e.RRuleText;
    this.OnRRuleChange();
  }

  HideRRule(e: any): void {
    this.showRRule = e;
  }

  SetDuplicateAppointment() {
    this.duplicateAppointmentForm = this.fb.group({
      selectedApptSubType: [],
      selectedBehaviourType: [],
      client_id: [this.appointment!.client_id, [Validators.required]],
      startDate: ['', [Validators.required]],
      selectedTrainer: [this.SelectedTrainerFormControl.value, [Validators.required]],
      selectedRoom: [],
      virtualUrl: [this.VirtualUrlFormControl.value],
      comments: [this.CommnetFormControl.value],
      //accepts_trial:[this.AcceptsTrialFormControl.value],
    });
    this.duplicateAppointment = true;
  }

  handleError(error: any) {
    this.error.next(error);
    this.showErrorPopup$.next(true);
  }

  handleToastError(error: any) {
    if (error.originalError.error.length > 0) {
      error.originalError.error.forEach((e: any) => {
        this.toastMessageService.showErrorMessage(e.errorMessage);
      });
    } else {
      this.toastMessageService.showErrorMessage(error.originalError.error.errorMessage);
    }
  }

  HideErrorPopup(event: any) {
    this.showErrorPopup$?.next(false);
    this.errorMessages = [];
  }

  CloseDuplicatePopup(event: any) {
    this.duplicateAppointment = event.closePopup;
    if (event.reloadData) this.reloadData.emit(true);
    this.CloseViewAppointmentSidebar();
  }

  clientStatus(client: any | null): string {
    if (client && (client.client_status || (client as any)?.client_status))
      return this.clientService.getClientStatusHtml(
        (client.client_status || (client as any)?.client_status).toString()
      );
    else return '';
  }

  GetClietMedicalDetails(client: any) {
    this.clientMedicalDetails = client;
    this.showMedicalAlert = true;
  }

  timeout(ms: any) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  ToggleVirtual(isVirtual: boolean) {
    this.isVirtal = isVirtual;
    if (isVirtual) {
      this.Actions.forEach(o => { if (o.key.toLowerCase() == 'convert_virtual') o.show = false });
      this.Actions.forEach(o => { if (o.key.toLowerCase() == 'convert_physical') o.show = true });
      this.SelectedRoomFormControl.setValidators(null);
      this.VirtualUrlFormControl.setValidators(null);
      this.UpdateVirtualUrl();
    } else {
      this.Actions.forEach(o => { if (o.key.toLowerCase() == 'convert_physical') o.show = false });
      this.Actions.forEach(o => { if (o.key.toLowerCase() == 'convert_virtual') o.show = true });
      this.SelectedRoomFormControl.setValidators(this.selectedApptType && this.selectedApptType.is_room_mandatory ? Validators.required : null);
      this.VirtualUrlFormControl.setValidators(null);
      if (this.selectedApptType.is_room_mandatory && (this.SelectedRoomFormControl.value == null || this.SelectedRoomFormControl.value == '')) {
        this.appointmentViewForm.markAllAsTouched();
      }
      else {
        this.UpdateRoom();
      }
    }
  }

  selectAction(action: any) {
    this.selectedAction = action.value;
    switch (this.selectedAction?.key) {
      case 'DUPLICATE':
        this.SetDuplicateAppointment();
        break;
      case 'CANCEL_APPT':
        this.cancelAppointment = true;
        break;
      case 'DELETE':
        this.cancelAppointment = true;
        break;
      case 'CONVERT_PHYSICAL':
        this.ToggleVirtual(false);
        break;
      case 'CONVERT_VIRTUAL':
        this.ToggleVirtual(true);
        break;
      case 'CONVERT_COMPLIMENTORY':
        this.showCompSessionPopup = true;
        break;
    }
  }

  checkStaffAvailability(event: any= null)
  {
    if(this.selectedApptType && this.StartDateFormControl.value && this.SelectedTrainerFormControl.value)
    {
      this.btnLoading=true;
      const endDateTime: Date = new Date(this.StartDateFormControl.value);
      endDateTime.setMinutes(endDateTime.getMinutes() + this.selectedApptType.duration_in_minutes);
      if (this.SelectedUpdateEventFormControlValue.toLowerCase() !== 'thisevent') {
        let request:CheckRecurringAvailability = {} as CheckRecurringAvailability;
        request.recurring_start_date = this.timeConversionService.ConvertLocalDateTimeToUTC(this.StartDateFormControl.value);
        request.recurring_end_date = this.timeConversionService.ConvertLocalDateTimeToUTC(endDateTime);
        request.start_time =  this.getTimeFromDateString(this.StartDateFormControl.value);
        request.end_time =  this.getTimeFromEndDateString(endDateTime);
        request.recurring_rule = this.RRuleObject.RRule;
        this.staffAvailabilityService.checkStaffAvailabilityForrecurringAppointment(this.tenantId, this.SelectedTrainerFormControl.value.id, this.selectedApptType.id, request).subscribe({
          next: async (response: StaffAvailableResponse) => {
            this.isStaffAvailable =response.result;
            this.availabilityResponseHandle(event);
          },
          error: (error:any) => {
            this.isStaffAvailable = true;
            this.availabilityResponseHandle(event);
          },
        });
      }
      else{
        this.staffAppointmentAvailability.set('start_date', { name: 'start_date', value: this.timeConversionService.ConvertLocalDateTimeToUTC(this.StartDateFormControl.value) });
        this.staffAppointmentAvailability.set('end_date', { name: 'end_date', value: this.timeConversionService.ConvertLocalDateTimeToUTC(endDateTime)});
        this.staffAvailabilityService.checkStaffAvailabilityForAppointment(this.tenantId, this.SelectedTrainerFormControl.value.id, this.selectedApptType.id, [...this.staffAppointmentAvailability.values()]).subscribe({
          next: async (response: StaffAvailableResponse) => {
            this.isStaffAvailable =response.result;
           this.availabilityResponseHandle(event);
          },
          error: (error:any) => {
            this.isStaffAvailable = true;
            this.availabilityResponseHandle(event);
          },
        });
      }
    }
  }

  availabilityResponseHandle(event:any)
  {
    if(this.isStaffAvailable)
    {
      switch (this.updateEvent) {
        case 'TrainerChange':
          {
              if (this.SelectedUpdateEventFormControlValue.toLowerCase() == 'thisevent')
                this.SubstituteCoach(this.currentRequestPayload);
              else this.SubstituteCoachInRecurring(this.currentRequestPayload);
          }
          break;
        case 'OnScheduleTimeChange':
        case 'OnScheduleDateSelect':
          {
              if (this.SelectedUpdateEventFormControlValue.toLowerCase() == 'thisevent')
                this.RescheduleAppointment(this.rescheduleDate);
              else
                this.RescheduleRecurringAppointments(this.rescheduleDate, this.rescheduleTime);
          }
          break;
      }
      this.btnLoading=false;
      this.showRecurringEventUpdatePopup = false;
      this.cd.detectChanges();
    }
    else{
      this.btnLoading=false;
      this.translate.get('STAFF_SCHEDULE.MSG.STAFF_UNAVAILABLE_MSG_LIN_INFO',{ name: this.SelectedTrainerFormControl.value.name })
      .subscribe((translation) => {
        this.toastMessageService.showWarning(translation)
      });
      this.confirm(event);
      this.cd.detectChanges();
    }
  }

  getTimeFromDateString(dateString:any) {
    if(dateString =='') return `00:00:00`;
    const date = this.timeConversionService.ConvertLocalDateTimeToUTCInDateObject(dateString);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;
    return formattedTime;
  }

  getTimeFromEndDateString(dateString:any) {
    if(dateString =='') return `00:00:00`;
    const date =   this.timeConversionService.ConvertLocalDateTimeToUTCInDateObject(dateString);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    date.setSeconds(-1);
    const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;
    return formattedTime;
  }

  getEndDate() {
    var newEndDate = new Date(this.StartDateFormControl.value);
    return new Date(newEndDate.setMinutes(this.StartDateFormControl.value.getMinutes() + this.appointment.duration_in_minutes));
  }

  ComplimentoryAppointment(form:any)
  {
    this.isComplimentoryLoading=true;
    this.appointmentService.MarkComplimentoryAppointment(this.tenantId,this.appointmentData.client_id,this.appointmentData.id,form.value).subscribe({
      next: (data:any) => {
        this.translate.get('CLIENT_BOOKING.COMP_COMPLETED')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
        this.isComplimentoryLoading=false;
        this.reloadData.emit(true);
        this.closeCompSessionPopup();
        this.cd.detectChanges();
      },
      error: (error:any) => {
        this.isComplimentoryLoading=false;
        this.toastMessageService.showError(error);
        this.cd.detectChanges();
      },
    });
  }

  closeCompSessionPopup()
  {
    this.showCompSessionPopup = false;
    this.selectedAction = undefined;
    this.appointmentViewForm.controls.selectedAction.setValue(null);
    this.complimentoryForm.reset();
  }

  get getActions() {
    return this.Actions.filter(o => o.show == true);
  }

  get SelectedTrainerFormControl(): UntypedFormControl {
    return this.appointmentViewForm.controls.selectedTrainer as UntypedFormControl;
  }

  get GetSelectedRoom(): any {
    return this.appointmentViewForm.controls.selectedRoom.value;
  }

  get Getcomments(): any {
    return this.appointmentViewForm.controls.comments.value;
  }

  get CommnetFormControl(): UntypedFormControl {
    return this.appointmentViewForm.controls.comments as UntypedFormControl;
  }

  get SelectedRoomFormControl(): UntypedFormControl {
    return this.appointmentViewForm.controls.selectedRoom as UntypedFormControl;
  }

  get VirtualUrlFormControl(): UntypedFormControl {
    return this.appointmentViewForm.controls.virtualUrl as UntypedFormControl;
  }

  get GetVirtualUrl(): any {
    return this.appointmentViewForm.controls.virtualUrl.value;
  }
  get StartDateFormControl(): UntypedFormControl {
    return this.appointmentViewForm.controls.startDate as UntypedFormControl;
  }

  get SelectedUpdateEventFormControlValue(): any {
    return this.updateEventForm.controls.updateEvent.value;
  }

  get AppointmentStatus(): typeof AppointmentStatus {
    return AppointmentStatus;
  }

  get formIsvalid(): boolean {
    return this.updateEventForm.valid;
  }

  get OStaffStatus(): Ienum<StaffStatus>[] {
    return Object.entries(StaffStatus).filter(key => typeof key[1] != 'number').map(([key, value]) => ({ key, value }));
  }



  // it will implemented after UAT
  // get AcceptsTrialFormControl(): UntypedFormControl {
  //   return this.appointmentViewForm.controls.accepts_trial as UntypedFormControl;
  // }

  // get GetAcceptsTrial(): any {
  //   return this.appointmentViewForm.controls.accepts_trial.value;
  // }


}